import React from "react";

const ReservationContainer = () => {
  return (
    <>
      <div className="flex flex-col gap-5 w-[694px] px-2">
        <div className="flex flex-col gap-4">
          <h1 className="text-[28px] font-semibold border-b-[1px] border-gray-400">
            Reservation
          </h1>
          <p className="text-[15px] font-medium">
            Reservation will be given as per the appropriate Government Policy.
            The Student should submit the testimonials along with their
            application forms to avail reservations under various course of
            CSSE.
            <h1 className="text-[17px] font-semibold text-amber-700 pb-2">
              Reservations under the Constitution: Right to equality
            </h1>
            Right to equality is an important right provided for in Articles 14,
            15, 16, 17 and 18 of the constitution. It is the principal
            foundation of all other rights and liberties, and guarantees the
            following:
            <h1 className="text-[17px] font-semibold text-amber-700 pb-2">
              Equality before law
            </h1>
            Article 14 of the constitution guarantees that all citizens shall be
            equally protected by the laws of the country. It means that the
            State cannot discriminate any of the Indian citizens on the basis of
            their caste, creed, colour, sex,gender, religion or place of birth.
            <h1 className="text-[17px] font-semibold text-amber-700 pb-2">
              Social equality and equal access to public areas
            </h1>
            Article 15 of the constitution states that no person shall be
            discriminated on the basis of caste, colour, language etc. Every
            person shall have equal access to public places like public parks,
            museums, wells, bathing Ghats and temples etc. However, the State
            may make any special provision for women and children. Special
            provisions may be made for the advancements of any socially or
            educationally backward class or scheduled castes or scheduled
            tribes.
            <h1 className="text-[17px] font-semibold text-amber-700 pb-2">
              Equality in matters of public employment
            </h1>
            Article 16 of the constitution laid down that the State cannot
            discriminate against anyone in the matters of employment. All
            citizens can apply for government jobs. There are some exceptions.
            The Parliament may enact a law stating that certain jobs can only be
            filled by applicants who are domiciled in the area. This may be
            meant for posts that require knowledge of the locality and language
            of the area. The State may also reserve posts for members of
            backward classes, scheduled castes or scheduled tribes which are not
            adequately represented in the services under the State to bring up
            the weaker sections of the society. Also, there a law may be passed
            which requires that the holder of an office of any religious
            institution shall also be a person professing that particular
            religion. According to the Citizenship (Amendment) Bill, 2003, this
            right shall not be conferred to overseas citizens of India.
            <h1 className="text-[17px] font-semibold text-amber-700 pb-2">
              Abolition of untouchability
            </h1>
            Article 17 of the constitution abolishes the practice of
            untouchability. Practice of untouchability is an offense and anyone
            doing so is punishable by law. [16] The Untouchability Offences Act
            of 1955 (renamed to Protection of Civil Rights Act in 1976) provided
            penalties for preventing a person from entering a place of worship
            or from taking water from a tank or well.
            <h1 className="text-[17px] font-semibold text-amber-700 pb-2">
              Abolition of Titles
            </h1>
            Article 18 of the constitution prohibits the State from conferring
            any titles. Citizens of India cannot accept titles from a foreign
            State. The British government had created an aristocratic class
            known as RaiBahadurs and Khan Bahadurs in India — these titles were
            also abolished. However, Military and academic distinctions can be
            conferred on the citizens of India. The awards of Bharat Ratna and
            Padma Vibhushan cannot be used by the recipient as a title and do
            not, accordingly, come within the constitutional prohibition". The
            Supreme Court, on 15 December 1995, upheld the validity of such
            awards.
          </p>
        </div>
      </div>
    </>
  );
};

export default ReservationContainer;
